import React, { useEffect, useState } from "react";
import { getAllMagazines } from "../lib/firebase/post/read_server"; // Adjust path if needed
import { getCategory } from "../lib/firebase/category/read_server"; // Add this import

export default function MagazinesPage() {
  const [magazines, setMagazines] = useState([]);

  useEffect(() => {
    async function fetchMagazines() {
      const fetchedMagazines = await getAllMagazines();
      setMagazines(fetchedMagazines);
    }
    fetchMagazines();
  }, []);

  if (!magazines || magazines.length === 0) {
    return (
      <div className="p-3">
        <h3>Magazines Not Available!</h3>
      </div>
    );
  }

  return (
    <section className="p-3">
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-4">
        {magazines.map((magazine, index) => (
          <MagazineCard magazine={magazine} key={index} />
        ))}
      </div>
    </section>
  );
}

function MagazineCard({ magazine }) {
  const month = magazine?.timestamp
    ? new Date(magazine.timestamp.toDate()).toLocaleString("default", {
        month: "long",
      })
    : "N/A";

  return (
    <a
      href={magazine?.pdfURL}
      target="_blank"
      rel="noopener noreferrer"
      className="col"
      style={{ textDecoration: "none" }}
    >
      <div
        className="card p-3 rounded-3"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.8) 100%), url(${magazine?.imageURL})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          height: "250px", // Fixed height for consistency
          color: "#fff", // White text
          position: "relative",
        }}
      >
        <div className="position-absolute top-0 end-0 p-1">
          <CategoryCard categoryId={magazine?.categoryId} />
        </div>
        <div className="card-body p-2 d-flex flex-column justify-content-end">
          <h5 className="card-title font-weight-bold mb-2">
            {magazine?.title}
          </h5>
          <div className="d-flex justify-content-between align-items-center">
            <p className="mb-0">{magazine?.productType}</p>
            <p className="mb-0">{magazine?.publishedBy}</p>
          </div>
          <p className="mb-0">{month}</p>
        </div>
      </div>
    </a>
  );
}

function CategoryCard({ categoryId }) {
  const [category, setCategory] = useState(null);

  useEffect(() => {
    async function fetchCategory() {
      const fetchedCategory = await getCategory(categoryId);
      setCategory(fetchedCategory);
    }
    fetchCategory();
  }, [categoryId]);

  return (
    <div className="d-flex gap-2 align-items-center bg-light rounded-pill px-2 py-1">
      <img
        className="rounded-circle"
        style={{ width: "30px", height: "30px" }}
        src={category?.iconURL}
        alt="Category"
      />
      <p className="text-muted mb-0 text-center">{category?.name}</p>
    </div>
  );
}
